import { render, staticRenderFns } from "./MessagesFeed.vue?vue&type=template&id=9938cad4&scoped=true"
import script from "./MessagesFeed.vue?vue&type=script&lang=js"
export * from "./MessagesFeed.vue?vue&type=script&lang=js"
import style0 from "./MessagesFeed.vue?vue&type=style&index=0&id=9938cad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9938cad4",
  null
  
)

export default component.exports